import React from 'react';
import styled from 'styled-components';
import { ExceptionButton } from '../../BrazilGrowerFinance/components/DecisionSheet/EditCreditExceptions.styles';
import i18next from 'i18next';
import { SmallBody } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { Link } from 'react-router-dom';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
  margin: 1rem 0;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  width: 100%;
`;

interface ImportedExceptionsConditionalsRedirectProps {
  exceptionsAlreadyAdded: string[];
  conditionalsAlreadyAdded: string[];
  parentId: string;
}

const ImportedExceptionsConditionalsRedirect = ({
  exceptionsAlreadyAdded,
  conditionalsAlreadyAdded,
  parentId
}: ImportedExceptionsConditionalsRedirectProps) => {
  const showButton = exceptionsAlreadyAdded.length > 0 || conditionalsAlreadyAdded.length > 0;

  if (!showButton) return null;

  return (
    <Wrapper>
      <SmallBody>
        <FontAwesomeIcon icon={faExclamationCircle} /> {i18next.t('creditExceptions-importedFrom')}
      </SmallBody>
      <ButtonsWrapper>
        <Link to={`/br-growers/${parentId}`}>
          <ExceptionButton>{i18next.t('creditExceptions-importedFrom-label')}</ExceptionButton>
        </Link>
      </ButtonsWrapper>
    </Wrapper>
  );
};

export default ImportedExceptionsConditionalsRedirect;
